/** Small pills: a status chip, a count badge, a key. Mono, quiet, and Signal only for down. */
import type { ReactNode } from 'react'
import { cx } from '../cx'
import { Light, type LightState } from './Light'
import s from './Chip.module.css'

/** A status or a tag. With `light`, a dot in that state leads the words. */
export function Chip({ tone = 'plain', light, children }: { tone?: 'plain' | 'work' | 'look' | 'down' | 'mute'; light?: LightState; children: ReactNode }) {
  return (
    <span className={cx(s.chip, s[tone])}>
      {light && <Light state={light} size="sm" />}
      {children}
    </span>
  )
}

/** A count beside a nav item or a tab. `down` only for things that wait on a person (open alerts). */
export function Badge({ count, tone = 'plain', label }: { count: number; tone?: 'plain' | 'down'; /** e.g. "2 open alerts" */ label?: string }) {
  return (
    <span className={cx(s.badge, tone === 'down' && s.badgeDown)} aria-label={label}>
      {count}
    </span>
  )
}

/** A key to press: ⌘K, Esc, Enter. */
export function Kbd({ children }: { children: ReactNode }) {
  return <kbd className={s.kbd}>{children}</kbd>
}
